import Popover from "@mui/material/Popover";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import styled from "styled-components";
export const FloatingMenuPopover = styled(Popover) `
    & .MuiPaper-root {
        background-color: rgba(255, 254, 252, 0.9);
        backdrop-filter: blur(5px);
        -webkit-backdrop-filter: blur(5px);
        border: 1px solid ${colors.separator_main};
        border-radius: 24px;
        box-shadow: 0px 162px 45px 0px rgba(0, 0, 0, 0), 0px 104px 42px 0px rgba(0, 0, 0, 0.02), 0px 58px 35px 0px rgba(0, 0, 0, 0.06),
            0px 26px 26px 0px rgba(0, 0, 0, 0.11), 0px 6px 14px 0px rgba(0, 0, 0, 0.13);
        padding: 4px 0;
        width: 272px;
        overflow: hidden;
    }

    & .MuiBackdrop-root {
        background-color: transparent;
    }

    @media print {
        display: none !important;
    }
`;
export const FloatingMenuItemIcon = styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    color: ${colors.black_main};

    & .MuiSvgIcon-root,
    & svg {
        color: currentColor;
    }
`;
export const FloatingMenuItemTextBlock = styled.div `
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    min-width: 0;
`;
export const FloatingMenuItemLabel = styled.span `
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.black_main};
    line-height: 21px;
    letter-spacing: -0.31px;
`;
export const FloatingMenuItemSubtitle = styled.span `
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.black_lighter};
    line-height: 18px;
`;
export const FloatingMenuItem = styled.button `
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 16px;
    width: 100%;
    background: transparent;
    border: none;
    border-bottom: 0.57px solid ${colors.separator_main};
    cursor: pointer;
    text-align: left;
    box-sizing: border-box;

    &:last-child {
        border-bottom: none;
    }

    @media (hover: hover) {
        &:hover:enabled {
            background-color: ${colors.black_4};
        }
    }

    &:disabled {
        cursor: default;
    }

    /* Solid disabled color on icon + text (no single opacity on the whole row) */
    &:disabled ${FloatingMenuItemIcon} {
        color: ${colors.navy_30_opaque};
    }
    &:disabled ${FloatingMenuItemLabel} {
        color: ${colors.navy_30_opaque};
    }
    &:disabled ${FloatingMenuItemSubtitle} {
        color: ${colors.navy_30_opaque};
    }
    /* Loading row: keep full contrast; spinner and label match enabled palette */
    &:disabled:where(:has(.MuiCircularProgress-root)) ${FloatingMenuItemIcon} {
        color: ${colors.black_main};
    }
    &:disabled:where(:has(.MuiCircularProgress-root)) ${FloatingMenuItemLabel} {
        color: ${colors.black_main};
    }

    &[data-destructive] ${FloatingMenuItemIcon} {
        color: ${colors.tulip_main};
    }
    &[data-destructive] ${FloatingMenuItemLabel} {
        color: ${colors.tulip_main};
    }
`;
